import { CUSTOM_ELEMENTS_SCHEMA, isDevMode, NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ComponentsModule } from './shared/components/components.module';
import { NinaModule } from './shared/components/nina/nina.module';
import { DebugConsoleModule, provideDebugConsole } from 'ngx-debug-console';

// Import RxDB plugins configuration early
import './shared/services/rxdb/rxdb-plugins.config';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [AppComponent],
    providers: [provideDebugConsole({ enabled: isDevMode() })],
    imports: [
        CoreModule,
        AppRoutingModule,
        ComponentsModule,
        NinaModule,
        DebugConsoleModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
